import React, { Component } from 'react';
import Grid from '../layout/grid';

class SearchableSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      search: '',
      highlightIndex: 0,
    };
    this.wrapperRef = null;
    this.searchInputRef = null;
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.selectOption = this.selectOption.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.options !== this.props.options) {
      this.setState({ highlightIndex: 0 });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  getFilteredOptions() {
    const { options = [], emptyOption, filterLocally = true } = this.props;
    const termo = (this.state.search || '').trim().toLowerCase();
    const lista = [];

    if (emptyOption) {
      lista.push(emptyOption);
    }

    options.forEach(opt => {
      if (
        !filterLocally ||
        !termo ||
        String(opt.label || '')
          .toLowerCase()
          .includes(termo)
      ) {
        lista.push(opt);
      }
    });

    return lista;
  }

  getSelectedLabel() {
    const { input, options = [], emptyOption, placeholder = 'Selecione...' } = this.props;
    const valor = (input.value !== null && input.value !== undefined) ? String(input.value) : '';

    if (!valor) {
      return emptyOption ? emptyOption.label : placeholder;
    }

    const encontrado = options.find(opt => String(opt.value) === valor);
    if (encontrado) return encontrado.label;

    return placeholder;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ open: false, search: '', highlightIndex: 0 });
      if (this.props.onSearchChange) {
        this.props.onSearchChange('');
      }
    }
  }

  toggleOpen() {
    const { disabled, readOnly } = this.props;
    if (disabled || readOnly) return;

    this.setState(
      prev => ({
        open: !prev.open,
        search: prev.open ? '' : prev.search,
        highlightIndex: 0,
      }),
      () => {
        if (this.state.open && this.searchInputRef) {
          setTimeout(() => this.searchInputRef && this.searchInputRef.focus(), 0);
        }
      },
    );
  }

  handleSearchChange(e) {
    const search = e.target.value;
    this.setState({ search, highlightIndex: 0 });
    if (this.props.onSearchChange) {
      this.props.onSearchChange(search);
    }
  }

  selectOption(option) {
    const { input, onSearchChange } = this.props;
    input.onChange(option ? String(option.value) : '');
    input.onBlur(option ? String(option.value) : '');
    this.setState({ open: false, search: '', highlightIndex: 0 });
    if (onSearchChange) {
      onSearchChange('');
    }
  }

  handleKeyDown(e) {
    const filtradas = this.getFilteredOptions();

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.setState(prev => ({
        open: true,
        highlightIndex: Math.min(prev.highlightIndex + 1, Math.max(filtradas.length - 1, 0)),
      }));
      return;
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.setState(prev => ({
        open: true,
        highlightIndex: Math.max(prev.highlightIndex - 1, 0),
      }));
      return;
    }

    if (e.key === 'Enter' && this.state.open && filtradas.length > 0) {
      e.preventDefault();
      this.selectOption(filtradas[this.state.highlightIndex]);
      return;
    }

    if (e.key === 'Escape') {
      e.preventDefault();
      this.setState({ open: false, search: '', highlightIndex: 0 });
    }
  }

  render() {
    const {
      label,
      cols,
      hideLabel,
      disabled,
      readOnly,
      searchPlaceholder = 'Pesquisar...',
      noResultsText = 'Nenhum resultado encontrado',
      hintText = '',
      loading = false,
      meta = {},
    } = this.props;
    const { open, search, highlightIndex } = this.state;
    const filtradas = this.getFilteredOptions();
    const valorAtual = (this.props.input.value !== null && this.props.input.value !== undefined) ? String(this.props.input.value) : '';
    const temErro = meta.touched && (meta.error || meta.warning);

    return (
      <Grid cols={cols}>
        <div
          className={`form-group form-group-sm searchable-select${open ? ' is-open' : ''}`}
          ref={ref => {
            this.wrapperRef = ref;
          }}
        >
          {hideLabel ? null : (
            <label className="label-gt" htmlFor={this.props.input.name}>
              {label}
            </label>
          )}

          <button
            type="button"
            className={`form-control searchable-select-trigger${temErro ? ' form-valid' : ''}`}
            onClick={this.toggleOpen}
            onKeyDown={this.handleKeyDown}
            disabled={disabled || readOnly}
            aria-haspopup="listbox"
            aria-expanded={open}
          >
            <span className={`searchable-select-value${!valorAtual ? ' is-placeholder' : ''}`}>
              {this.getSelectedLabel()}
            </span>
            <i className={`fa fa-chevron-${open ? 'up' : 'down'} searchable-select-chevron`} />
          </button>

          {open && (
            <div className="searchable-select-panel">
              <div className="searchable-select-search-wrap">
                <input
                  ref={ref => {
                    this.searchInputRef = ref;
                  }}
                  type="text"
                  className="form-control searchable-select-search"
                  value={search}
                  onChange={this.handleSearchChange}
                  onKeyDown={this.handleKeyDown}
                  placeholder={searchPlaceholder}
                  autoComplete="off"
                />
              </div>

              <div className="searchable-select-options" role="listbox">
                {hintText && !search ? <div className="searchable-select-hint">{hintText}</div> : null}
                {loading ? (
                  <div className="searchable-select-empty">
                    <i className="fa fa-spinner fa-spin" /> Buscando...
                  </div>
                ) : filtradas.length === 0 ? (
                  <div className="searchable-select-empty">{noResultsText}</div>
                ) : (
                  filtradas.map((opt, idx) => {
                    const selecionado = String(opt.value) === valorAtual;
                    const destacado = idx === highlightIndex;
                    return (
                      <button
                        key={`${opt.value}-${idx}`}
                        type="button"
                        className={`searchable-select-option${selecionado ? ' is-selected' : ''}${
                          destacado ? ' is-highlighted' : ''
                        }`}
                        onMouseEnter={() => this.setState({ highlightIndex: idx })}
                        onClick={() => this.selectOption(opt)}
                      >
                        {opt.label}
                      </button>
                    );
                  })
                )}
              </div>
            </div>
          )}
        </div>
      </Grid>
    );
  }
}

export default SearchableSelect;
